import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { MyWorkService } from '../services/sections/job/my-work.service';

@Injectable({
	providedIn: 'root'
})
export class IsVendorResolver implements Resolve<Observable<boolean>> {

	constructor(
		private router: Router,
		private myWorkService: MyWorkService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.myWorkService
			.isVendor(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
